import { User, Menu } from "@/api";
import { Module, VuexModule, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "@/store/index";
import { UserRegisterStatus, EditStatus } from "@/types";

export interface IUserModule {
  _users: User[];
  _user: User | null;
  _preRegisterStatus: UserRegisterStatus;
  _registerStatus: UserRegisterStatus;
  _editStatus: EditStatus | null;
}

@Module({ dynamic: true, store, name: "user", namespaced: true, preserveState: false })
class UserModule extends VuexModule implements IUserModule {
  public _users: User[] = [];

  public _user: User | null = null;

  public _preRegisterStatus: UserRegisterStatus = UserRegisterStatus.Edit;

  public _registerStatus: UserRegisterStatus = UserRegisterStatus.Edit;

  public _editStatus: EditStatus | null = null;

  @Mutation
  public changeUsers(users: User[]) {
    this._users = users;
  }

  @Mutation
  public changeUser(user: User) {
    this._user = user;
  }

  @Mutation
  public changePreRegisterStatus(status: UserRegisterStatus) {
    this._preRegisterStatus = status;
  }

  @Mutation
  public changeRegisterStatus(status: UserRegisterStatus) {
    this._registerStatus = status;
  }

  @Mutation
  public changeEditStatus(editStatus: EditStatus | null) {
    this._editStatus = editStatus;
  }

  @Action({ rawError: true })
  public commitUsers(users: User[]) {
    this.context.commit("changeUsers", users);
  }

  @Action({ rawError: true })
  public commitUser(user: User) {
    this.context.commit("changeUser", user);
  }

  @Action({ rawError: true })
  public commitMenus(menus: Menu[]) {
    this.context.commit("changeMenus", menus);
  }

  @Action({ rawError: true })
  public commitPreRegisterStatus(status: UserRegisterStatus) {
    this.context.commit("changePreRegisterStatus", status);
  }

  @Action({ rawError: true })
  public commitRegisterStatus(status: UserRegisterStatus) {
    this.context.commit("changeRegisterStatus", status);
  }

  @Action({ rawError: true })
  public commitEditStatus(editStatus: EditStatus | null) {
    this.context.commit("changeEditStatus", editStatus);
  }

  public get users() {
    return this._users || [];
  }

  public get user() {
    return this._user || null;
  }

  public get preRegisterStatus() {
    return this._preRegisterStatus || UserRegisterStatus.Edit;
  }

  public get registerStatus() {
    return this._registerStatus || UserRegisterStatus.Edit;
  }

  public get editStatus() {
    return this._editStatus || null;
  }
}

export default getModule(UserModule);
